import { gql } from '@apollo/client';

export const getNftReferencesByArticleIdQuery = gql`
  query getNftReferencesByArticleId($articleId: ID!) {
    nftReferences(where: { article: { id: { equals: $articleId } } }) {
      id
      chainId
      address
      tokenId
      name
      description
      price
      saleEnd
      image {
        id
        publicUrl
        publicUrlTransformed
        _meta {
          public_id
          height
          width
        }
      }
      nftCollectionReference {
        id
        chainId
        address
        name
        description
        image {
          id
          publicUrl
          publicUrlTransformed
          _meta {
            public_id
            height
            width
          }
        }
      }
    }
  }
`;
